import ConfirmationBox from "./confirmationBox";
import confirmationBoxReducer, {initialState} from "./confirmationBoxSlice";

export {initialState, confirmationBoxReducer};
export default ConfirmationBox;